import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var getDefaultStyleSheet = _ref => {
  var {
    colorToken,
    colorTokenArgs,
    designContext,
    disabled,
    green,
    percentage
  } = _ref;
  var borderRadius = designContext.get('progress-bar/corner-radius').pixelValue;
  return {
    container: {
      backgroundColor: designContext.get('progress-bar/background-color').toString(),
      borderRadius,
      height: 5,
      overflow: 'hidden'
    },
    fill: {
      backgroundColor: designContext.get(colorToken || 'progress-bar/fill-color', _objectSpread({
        interactiveState: disabled ? 'disabled' : 'default',
        successState: green ? 'success' : 'default'
      }, colorTokenArgs ? colorTokenArgs : {})).toString(),
      borderBottomLeftRadius: borderRadius,
      borderTopLeftRadius: borderRadius,
      height: '100%',
      transition: 'width .2s ease',
      width: "".concat(percentage, "%")
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map